import { render, staticRenderFns } from "./TutorEssayStatistics.vue?vue&type=template&id=2ad18c40&"
import script from "./TutorEssayStatistics.vue?vue&type=script&lang=js&"
export * from "./TutorEssayStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports